import React from 'react';
import Footer from "../../components/footer";
import Header from "../../components/header";
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { getPatientRecordReqList, chargeFinalCost, downloadRecords } from "../../services/patient/action";
import { viewRequestInfo } from "../../services/common/action";
import {fedexTrackingApi, InitialfedexTrack} from "../../services/employee/action";
import { NavLink } from "react-router-dom";
import { footer } from "../../components/footerSize"
import DeleteModel from "../common/Model/deleteModel"
import DownloadModel from "./downLoadModel"
import Model from "../common/model";
import Pagination from '../common/pagination';
import moment from "moment";
import { toast } from 'react-toastify';
import {  onlyNumbers} from "../common/keyValidation"

class PatientHome extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            requestInfoList: [],
            openPopUp: false,
            facilityName: "",
            mobile: "",
            email: "",
            address: "",
            address2: "",
            city: "",
            faciState: "",
            doctorLastName: "",
            firstName: "",
            lastName: "",
            extraCost: 0,
            fedexCost: 0,
            finalCost: 0,
            pageCost: 0,
            pageCount: "",
            serviceCharge: 0,
            upchargeCost: 0,
            hedisCost: 0,
            downloadPopup: false,
            downloadresquestID: "",
            src: "",
            pageOfItems: [],
            deliveryMode:"",
            fedexTrackingNo:"",
            openTrackPop: false,
            fedexModel_text : "",
            requestStatus:"",
            otherRequestorDocURL:"",
            searchInput:null,
            baseList:[]

        }
    }

    onChangePage = (pageOfItems) => {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }


   

    componentWillReceiveProps = nextProps => {
        if (nextProps.paymentMethodNotAddedStatus) {
            this.props.history.push("/Settings")
        }
        if (nextProps.fedexTrackingStatus) {
            let message = nextProps.fedexTrakingDetails.fedexNotificationDTO ? nextProps.fedexTrakingDetails.fedexNotificationDTO : ""
            document.body.classList.add('modal-open');
            this.setState({
                openTrackPop: true,
                fedexModel_text: message.Message ? message.Message : "No tracking number",
            })
        }
        if (nextProps.PatientReqInfoStatus) {
            if (nextProps.PatientReqInfoList) {

                let requestInfoList = nextProps.PatientReqInfoList.requestInfoList;
                this.setState({
                    requestInfoList,
                     baseList: requestInfoList,
                })

            }

        }
        if (nextProps.viewRequestInfoStatus) {
            this.setState({
             })
            let reqRecordInfo = nextProps.viewRequestInfoDetails.requestInfoDetailes
            this.appendToModelReq(reqRecordInfo);
        }
        if (nextProps.downloadRecordService) {
            let src = nextProps.downloadRecordDetails.url;
          //  document.body.classList.add('modal-open');

            this.setState({
                downloadPopup: true,
                src
            })
        }
    }
    appendToModelReq = (req) => {

        let firstName = req.firstName ? req.firstName : "";
        let lastName = req.lastName ? req.lastName : "";
        let extraCost = req.extraCost ? req.extraCost : 0;
        let fedexCost = req.fedexCost ? req.fedexCost : 0;
        let finalCost = req.finalCost ? req.finalCost : 0;

        let pageCost = req.pageCost ? req.pageCost : 0;
        let pageCount = req.pageCount ? req.pageCount : 0;
        let serviceCharge = req.serviceCharge ? req.serviceCharge : 0;
        let upchargeCost = req.upchargeCost ? req.upchargeCost : 0;
        let hedisCost = req.hedisCost ? req.hedisCost : "";
        let deliveryMode = req.deliveryMode ? req.deliveryMode : "";
        let fedexTrackingNo = req.fedexTrackingNo ? req.fedexTrackingNo : 0;
        let otherRequestorDocURL = req.otherRequestorDocURL ? req.otherRequestorDocURL : "";

        // finalCost = pageCost + extraCost + fedexCost +serviceCharge +upchargeCost 

        this.setState({

            firstName,
            lastName,
            extraCost,
            fedexCost,
            finalCost,
            pageCost,
            pageCount,
            serviceCharge,
            upchargeCost,
            hedisCost,
            deliveryMode,
            fedexTrackingNo,
            otherRequestorDocURL
        })
    }
    appendToModel = (req) => {


        let facilityName = req.facilityName ? req.facilityName : "";
        let mobile = req.mobile ? req.mobile : "";
        let email = req.email ? req.email : "";
        let faciState = req.faciState ? req.faciState : "";
        let address = req.address ? req.address : "";
        let address2 = req.address2 ? req.address2 : "";
        let city = req.city ? req.city : "";
        let doctorLastName = req.doctorLastName ? req.doctorLastName : "";
        let requestStatus = req.requestStatus ? req.requestStatus : "";



        this.setState({

            facilityName,
            mobile,
            email,
            address,
            address2,
            city,
            faciState,
            doctorLastName,
            requestStatus




        })
    }

        searchInputChange = (e) => {
        toast.dismiss()
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },() => {
            if(this.state.baseList.length > 0){
                let reqId = this.state.searchInput;
                let length = this.state.baseList[0].requestId
                if (reqId) {
                  //  if (reqId <= length reqId<=) {
                        let list = this.state.baseList;
                        
                           let filtered = list.filter(item =>{
                             
                                 if ((item.requestId.toString()).includes(reqId) || ( item.thirdPartyRequestId && (item.thirdPartyRequestId.toString()).includes(reqId))) {
                                        return item
                                    }
                            })

                         if (filtered.length >= 1) {
                            this.setState({
                                requestInfoList: filtered
                            })
                        } else {
                            toast.dismiss()
                            toast.error("No Request found with Id number " + this.state.searchInput, { autoClose: 2000 })
                            this.setState({
                                requestInfoList: this.state.baseList
                            })
                        }
                    }
                    //  else if (reqId > length) {
                    //     toast.dismiss()
                    //     toast.error("No Request found with Id number " + this.state.searchInput, { autoClose: 2000 })
                    //     this.setState({
                    //         requestInfoList: this.state.baseList
                    //     })
                    // }
                //} 
                else {
                    this.setState({
                        requestInfoList: this.state.baseList
                    })
                }
            }else {
                toast.dismiss()
                toast.error("No Request found ", { autoClose: 2000 })

            }
            });
    }


    filterWithReqId = () => {

        let reqId = this.state.searchInput;
        if (reqId) {
            let list = this.state.baseList;
            let filtered = list.filter(item => {
                if (item.requestId == reqId || item.thirdPartyRequestId == reqId) {
                    return item
                }
            })
            this.setState({
                requestInfoList: filtered
            })
        } else {
            this.setState({
                requestInfoList: this.state.baseList
            })
        }
    }

    closeDownloadPopup = () => {
      //  document.body.classList.remove('modal-open');

        this.setState({
            confirmPopUp: false
        })
    }

    closePop = () => {
       // document.body.classList.remove('modal-open');

        this.setState({
            confirmPopUp: false
        })
    }

    confirmDownload = () => {
       // document.body.classList.remove('modal-open');

        this.setState({
            downloadPopup: false
        }, () => {

            let token = this.props.loginDetails;
            let requestId = this.state.downloadresquestID
            let id = {
                requestId
            }


            let userId;
            if (this.props.profileDetails) {
                userId = this.props.profileDetails.commonUser.userId;

            }

            this.props.downloadRecords(token, userId, id);
        })
    }
    closeDownload = () => {
      //  document.body.classList.remove('modal-open');

        this.setState({
            downloadPopup: false
        })
    }

    openTrackPopUp = () => {

        let token = this.props.loginDetails;
        let fedexNo = this.state.fedexTrackingNo;
        let payload = {
            trackingNumber: fedexNo
        }


        this.props.fedexTrackingApi(token, payload)
    }

    closeTrackPop = () => {
        this.props.InitialfedexTrack()
        document.body.classList.remove('modal-open');
            this.setState({
                openTrackPop: false
            })
        }


    confirmOkay = () => {
       // document.body.classList.remove('modal-open');

        this.setState({
            confirmPopUp: false
        }, () => {

            let token = this.props.loginDetails;
            let requestId = this.state.requestId

            let payload = {
                requestId
            }
            let userId;
            if (this.props.profileDetails) {
                userId = this.props.profileDetails.commonUser.userId;

            }


            this.props.chargeFinalCost(token, userId, payload);
        })


    }

    chargeCost = (id) => {
        let requestId = id
        this.setState({
            requestId
        }, () => {
          //  document.body.classList.add('modal-open');

            this.setState({
                confirmPopUp: true
            })
        })

    }

    downloadRec = (requestId) => {
        let token = this.props.loginDetails;
        let id = {
            requestId
        }


        let userId;
        if (this.props.profileDetails) {
            userId = this.props.profileDetails.commonUser.userId;

        }

        this.props.downloadRecords(token, userId, id);
    }
    viewDetails = (e, req) => {

        e.preventDefault();
        let access_token = this.props.loginDetails;
        this.appendToModel(req);
        let payload = {
            requestId: req.requestId
        }
      //  document.body.classList.add('modal-open');

        this.setState({
            openPopUp: true
        })
        this.props.viewRequestInfo(access_token, payload)
    }

    componentDidMount() {
            // onDocumentReady function bind
            $(document).ready(function () {
                footer("#content");
            });
    
            // onResize bind of the function
            $(window).resize(function () {
                footer("#content");
            });
            let access_token = this.props.loginDetails;
            if (this.props.profileDetails) {
                let userId = this.props.profileDetails.commonUser.userId;
    
                this.props.getPatientRecordReqList(access_token, userId);
                this.props.InitialfedexTrack();
            }
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        });
    }

    CloseOpenPopUp = () =>{
      //  document.body.classList.remove('modal-open');

        this.setState({
            openPopUp : false
        })
    }



    render() {

        console.log("jhjhjhh", this.props)

        const {

            extraCost,
            fedexCost,
            finalCost,
            pageCost,
            pageCount,
            serviceCharge,
            hedisCost,
            deliveryMode,
            fedexTrackingNo,
            requestStatus,
            otherRequestorDocURL,
            searchInput
        } = this.state

        return (
            <React.Fragment>
                <Header status={"afterLogin"} routes={[{ "name": "Home", "route": "/PatientHome", }]} />
                <div className="content">

                    <div className="contentSection" id="content">
                        <div className="container-fluid add">

                            <div className="bodyContent">

                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                                        <NavLink to="/PatientRequest">  <button type="button" className="btnDefault"><i className="fa fa-plus" aria-hidden="true"></i> Request New Records</button></NavLink>
                                         
                                    </div>
                                     
                                    
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        {/* <div className="titleBg">
                                           
                                            
                                        </div> */}
                                         <div className="titleBg">
                                            <div class="row mb-2">
                                                <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12">
                                                     <h4> Requested Records  </h4>
                                                 </div>
                                             
                                                     <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 text-right">
                                                        <div className="search-section" style={{marginTop:"10px"}}>
                                                            <input type="text" name="searchInput" style={{width: "85%"}} value={searchInput} onKeyPress={onlyNumbers} onChange={this.searchInputChange} className="search-input" placeholder={this.props.profileDetails.commonUser.userType === "other" ? "Search with Request Id or Thirdparty Request Id" : "Search with Request Id"} />
                                                            <div class="search-icon">
                                                                <button><i class="fa fa-search" onClick={this.filterWithReqId} aria-hidden="true"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                   
                                            </div>
                                        </div>
                                           
                                        <div className="table-responsive">
                                            <div className=" overtooltip">
                                                <table className="table commonTable">
                                                    <thead>
                                                        <tr>
                                                            <th>Request Id</th>
                                                            <th>Status</th>
                                                            <th>Requested Date</th>
                                                            {this.props.profileDetails.commonUser.userType === "other" && <th>Third Party Request Id </th>}
                                                            <th>Practice/Doctor</th>
                                                            <th>Estimated Page Count
                                                            <div className="pagecount-tool">
                                                                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                                                                    <div className="pagecount-showing">
                                                                        <p>This is your estimated page count. We cannot know the actual page count until the entire record has been produced. If your records have been produced already then this represents your final page count.</p>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th>Estimated Cost
                                                        <div className="pagecount-tool">
                                                                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                                                                    <div className="pagecount-showing">
                                                                        <p>This is your estimated cost. We cannot know the actual cost until the entire record has been produced. If your records have been produced already then this represents your final cost.</p>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th>View</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.pageOfItems.length > 0 ?
                                                            this.state.pageOfItems.map((req, id) => {
                                                                return (
                                                                    <tr key={id}>
                                                                        <td>{req.requestId} </td>
                                                                        <td><span className="statusconform"
                                                                            title={req.requestStatus === "Requested" ? "Records Requested" : req.requestStatus === "Pending" ? "Payment Pending" : req.requestStatus === "Completed" ? "Payment Completed Records are Ready" : ""} >
                                                                            {req.requestStatus === "Requested" ? "R" : req.requestStatus === "Pending" ? "P" : req.requestStatus === "Completed" ? "C" : ""}</span></td>
                                                                         <td>{moment(req.createdDate).format('MMM Do YYYY')} </td>
                                                                            {this.props.profileDetails.commonUser.userType === "other" && <td> {req.thirdPartyRequestId} </td>}
                                                                        <td><span>{req.facilityName}</span> <span>Dr. {req.doctorLastName}</span></td>
                                                                        <td>{req.pageCount}</td>
                                                                        <td>{req.finalCostInDecimal}</td>
                                                                        <td><a href="javascript:void(0)" onClick={(e) => this.viewDetails(e, req)} className="icon" title="View-Details"><i class="fa fa-eye" aria-hidden="true"></i></a></td>
                                                                        <td className="pad- sd"><button onClick={() => this.downloadRec(req.requestId)} disabled={req.requestStatus === "Requested" ? true : req.requestStatus === "Pending" ? true : req.requestStatus === "Completed" ? false : ""} className="icon downloadbttn" title="Download">
                                                                            <i className="fa fa-download" aria-hidden="true"></i></button>
                                                                            {!req.isAutoPay &&
                                                                                <button
                                                                                    disabled={req.requestStatus === "Requested" ? true : req.requestStatus === "Pending" ? false : req.requestStatus === "Completed" ? true : ""}
                                                                                    onClick={() => this.chargeCost(req.requestId)} className="action-btn dollarbttn" >
                                                                                    <i class="fa fa-usd" aria-hidden="true"></i>
                                                                                </button>}
                                                                        </td>




                                                                    </tr>
                                                                )
                                                            }) : <tr style={{ background: "transparent" }}><td colspan="10" style={{paddingTop : "30px"}}> Please make a records request by clicking on request new records button in the upper right-hand corner of this page</td></tr>

                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">

                                        <Pagination items={this.state.requestInfoList} onChangePage={this.onChangePage} />

                                    </div>
                                </div>


                            </div>

                        </div>

                    </div>
                </div>

                <Footer />
                {this.state.openPopUp &&
                    <div class="creatTasks">
                        <div class="modal fade in " id="createtask" role="dialog">
                            <div class="modal-dialog">
                                <div class="modal-content bill-model-design">
                                    <div class="modal-header">
                                        <h4 class="modal-title">Requested Records Details</h4>
                                        <button type="button" class="close" onClick={() => { this.setState({ openPopUp: false }) }} >&times;</button>
                                    </div>

                                    <div class="modal-body">

                                        <div class="createtaskbody ">
                                            <div class="bgdefet">
                                                <div class="row">
                                                    <div class="settingpage-table">
                                                        <table>

                                                            <tr>
                                                                <td class="heading-table-title">Expedited Fee</td>
                                                                <td>&#36; {serviceCharge} </td>
                                                            </tr>

                                                            <tr>

                                                                <td class="heading-table-title">Page Count</td>
                                                                <td>{pageCount} </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="heading-table-title">Total page Cost</td>
                                                                <td>&#36; {pageCost} </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="heading-table-title">State Base Fee</td>
                                                                <td>&#36; {extraCost} </td>
                                                            </tr>

                                                            <tr>
                                                                <td class="heading-table-title">FedexCost</td>
                                                                <td>&#36; {fedexCost} </td>
                                                            </tr>

                                                            {hedisCost &&
                                                                <tr>
                                                                    <td class="heading-table-title">HedisCost</td>
                                                                    <td>&#36; {hedisCost} </td>
                                                                </tr>
                                                            }
                                                            <tr>
                                                                <td class="heading-table-title"></td>
                                                                <td><span class="heading-table-title">Total Cost:</span>&#36; {finalCost} </td>
                                                            </tr>
                                                         
                                                              
                                                        </table>
                                                        {requestStatus === "Completed" &&
                                                        <div className="track-section">
                                                                        {deliveryMode.includes("fedex") &&
                                                                    <>
                                                                            <label for="phone" className="fw600">Fedex Tracking No</label>
                                                                            < input type="text" disabled="true" value={fedexTrackingNo} />
                                                                            <button type="button" title="Track" onClick={this.openTrackPopUp}>Track</button>
                                                                                      
                                                                    </>
                                                                }
 
                                                                        </div>
                                                        }
                                                                {/* {otherRequestorDocURL &&
                                                        <div className="bgdefet1">
                                                            <h4 className="pract1">Document</h4>
                                                            <div  >
                                                                <iframe title="title" src={otherRequestorDocURL} style={{ width: "100%", height: "100vh" }} ></iframe>

                                                            </div>
                                                            <button class="btnDefault"><a href={otherRequestorDocURL} target="_blank" rel="noopener noreferrer" download> Download</a></button>
                                                        </div>
                                                    } */}


                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div class="bgdefet">
                                            <div class="modal-footer1">
                                                <button type="button" onClick={this.CloseOpenPopUp} class="btngeo clearbtn">Close</button>
                                                {/* <button type="button"  onClick={()=>{this.setState({openPopUp:false})}} class="btngeo submitbtn clr448aff" data-dismiss="modal">Submit</button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <DeleteModel text="DO YOU WANT TO COMPLETE THIS PAYMENT " status={this.state.confirmPopUp} closePop={this.closePop} confirmOkay={this.confirmOkay} />
                <DownloadModel status={this.state.downloadPopup} closePop={this.closeDownloadPopup} src={this.state.src} closeDownload={this.closeDownload} />
                <Model header="Tracking Status" page="tracking" text={this.state.fedexModel_text} status={this.state.openTrackPop} confirmOkay={this.closeTrackPop} />

            </React.Fragment>

        )
    }
}

const mapStateToProps = state => ({    
    fedexTrackingStatus: state.employeeReducer.fedexTrackingStatus,
    fedexTrakingDetails: state.employeeReducer.fedexTrakingDetails,
    profileDetails: state.commonReducer.profileDetails,
    loginDetails: state.commonReducer.loginDetails,
    PatientReqInfoList: state.patientReducer.PatientReqInfoList,
    PatientReqInfoStatus: state.patientReducer.PatientReqInfoStatus,
    viewRequestInfoStatus: state.commonReducer.viewRequestInfoStatus,
    downloadRecordService: state.patientReducer.downloadRecordService,
    downloadRecordDetails: state.patientReducer.downloadRecordDetails,
    viewRequestInfoDetails: state.commonReducer.viewRequestInfoDetails,
    paymentMethodNotAddedStatus: state.patientReducer.paymentMethodNotAddedStatus
});
const mapDispatchToProps = dispatch => ({
    getPatientRecordReqList: (token, patientId, ) => dispatch(getPatientRecordReqList(token, patientId)),
    viewRequestInfo: (token, payload, ) => dispatch(viewRequestInfo(token, payload)),
    fedexTrackingApi: (token, payload, ) => dispatch(fedexTrackingApi(token, payload)),
    chargeFinalCost: (token, userId, payload, ) => dispatch(chargeFinalCost(token, userId, payload)),
    downloadRecords: (token, userId, id, ) => dispatch(downloadRecords(token, userId, id)),
    InitialfedexTrack : () => dispatch(InitialfedexTrack()),


});
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(PatientHome));
